import { Alert } from "antd";
import ErrorAppContent from "../ErrorAppContent";
import Logout from "../LogOut";

interface ErrorStatesProps {
    loadingLogout: boolean;
    loading: boolean;
    loginStatus: string;
    permittedCustomersError: string;
    permittedCustomers: any[];
    permittedCustomersLoading: boolean;
    authLoading: boolean;
}

export default function ErrorStates({
    loadingLogout,
    loading,
    loginStatus,
    permittedCustomersError }: ErrorStatesProps) {
    // General error state
    if (!loadingLogout && !loading && loginStatus !== "error" && permittedCustomersError?.length > 0) {
        return <ErrorAppContent />;
    }

    // No customers error
    const shouldShowNoCustomersError =
        !loadingLogout &&
        loginStatus !== 'error' &&
        permittedCustomersError?.length > 0;

    if (shouldShowNoCustomersError) {
        return (
            <div className="centerContainer">
                <Alert
                    message="No customers found!"
                    description="Please contact your administrator."
                    type="error"
                    showIcon
                    style={{ width: "100%", fontSize: "20px" }}
                    action={<Logout />}
                />
            </div>
        );
    }

    return null;
}
